module.exports = __webpack_public_path__ + "img/banner_left.1fa8a9fe.jpg";